import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { ApiService } from '@core/providers/http';
import { BehaviorSubject, catchError, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CurtidaService {
  public params = new HttpParams();
  private userLikesMap = new Map<number, number>(); // campanhaID -> curtidaID
  public userLikes$ = new BehaviorSubject<Map<number, number>>(new Map());

  constructor(private readonly apiService: ApiService) {}

  list(params?: any): Observable<any> {
    return this.apiService
      .get(
        `/Curtidas`,
        params
          ? new HttpParams({
              fromObject: params,
            })
          : this.params,
      )
      .pipe(map((response) => response));
  }

  /**
   * Cria um novo Curtida
   * @param Curtida
   * @returns Observable<any>
   */
  public store(Curtida: any): Observable<any> {
    return this.apiService.post(`/Curtidas`, Curtida);
  }

  /**
   * atualizar Curtida
   * @param Curtida
   * @returns Observable<any>
   */
  public update(Curtida: any): Observable<any> {
    return this.apiService.put(`/Curtidas`, Curtida);
  }

  show(id: string): Observable<any> {
    return this.apiService
      .get(`/Curtidas/${id}`)
      .pipe(map((response) => response));
  }

  delete(id: number): Observable<any> {
    return this.apiService.delete(`/Curtidas/${id}`);
  }

  // ── MÉTODOS DE CACHE E SINCRONIZAÇÃO ──
  getUserLikesMap(): Map<number, number> {
    return this.userLikesMap;
  }

  isCampanhaLiked(campanhaId: number | string): boolean {
    return this.userLikesMap.has(Number(campanhaId));
  }

  getCurtidaId(campanhaId: number | string): number | undefined {
    return this.userLikesMap.get(Number(campanhaId));
  }

  recordLike(campanhaId: number | string, curtidaId: number): void {
    if (!campanhaId) return;
    this.userLikesMap.set(Number(campanhaId), Number(curtidaId));
    this.userLikes$.next(new Map(this.userLikesMap));
  }

  removeLike(campanhaId: number | string): void {
    if (!campanhaId) return;
    this.userLikesMap.delete(Number(campanhaId));
    this.userLikes$.next(new Map(this.userLikesMap));
  }

  loadUserLikes(userId: string): Observable<Map<number, number>> {
    if (!userId) {
      this.userLikesMap.clear();
      this.userLikes$.next(new Map());
      return of(this.userLikesMap);
    }

    const params = {
      UtilizadorID: userId,
      PageSize: 500,
      PageNumber: 1,
    };

    return this.list(params).pipe(
      map((res: any) => {
        const rawList =
          res?.data?.items ??
          (Array.isArray(res?.data) ? res.data : (res?.items ?? []));
        const list = Array.isArray(rawList) ? rawList : [];
        this.userLikesMap.clear();
        list.forEach((item: any) => {
          const cId = item?.campanhaID ?? item?.campanhaId;
          const lId = item?.id ?? item?.curtidaID ?? item?.curtidasId;
          if (cId && lId) {
            this.userLikesMap.set(Number(cId), Number(lId));
          }
        });
        this.userLikes$.next(new Map(this.userLikesMap));
        return this.userLikesMap;
      }),
      catchError((err) => {
        console.error('Erro ao carregar curtidas do utilizador:', err);
        return of(this.userLikesMap);
      }),
    );
  }
}
